export { default as TextExpander } from './text-expander';
